<template>
  <div id="grid-destruccion">
    <v-container grid-list-xl fluid>
      <v-layout>
        <carga-masiva
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
        >
        </carga-masiva>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="itemsDestruccion"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.idNivel }}</td>
                <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                <td class="text-xs-left">{{ props.item.total }}</td>
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Consulta escaneo"
                    @click="
                      viewDestruccion(props.item.idNivel, props.item.tipoPrueba)
                    "
                  >
                    <v-icon>remove_red_eye</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </template>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              class="btn-sigas"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
            >
              <v-icon>remove_red_eye</v-icon> </v-btn
            >Consultar
          </v-card-actions>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import CargaMasiva from "@/components/CargaMasiva.vue";

export default {
  name: "grid-destruccion",

  components: {
    AlertEmpty,
    Loading,
    CargaMasiva,
  },
  props: {
    rowsTable: "",
    tipeView: "",
  },

  data() {
    return {
      botonDescarga: false,
      dialogLoading: false,
      botonDescarga: false,
      selected: [],
      loading: false,
      loading1: false,
      tipeArchive: "",
      alerta: false,
      dialog: false,
      id: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      idContrato: "",
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "idNivel" },
        { text: "Tipo Prueba", sortable: false, value: "tipoPrueba" },
        { text: "Total Registros", sortable: false, value: "total" },
        { text: "Accion", sortable: false, value: "" },
      ],
      itemsDestruccion: [],
      usuarioLoggedTipe: "",
      idUserLogged: "",
      proceso: "",
      documentoSelect: [],
      documentoValue: null,
      tipoPruebaSelect: [],
      tipoPruebaValue: null,
      nivelValue: null,
      nivelSelect: [],
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
    };
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;

    //se indican las apis a utilizar
    this.apiValidateDocument = "/destruccion/preProcessFile";
    this.apiSaveDocument = "/destruccion/saveMassive";
    this.apiDownloadDocument = "/destruccion/downloadPlantilla/";
    this.templateTitle = "PLANTILLA_DESTRUCCION";

    this.loadData();
  },
  mounted() {},
  computed: {},
  methods: {
    async loadDestruccionFilter() {
      return await axios
        .get("/destruccion/sumary/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadData() {
      // this.loading = true;

      this.itemsDestruccion = await this.loadDestruccionFilter();

      // this.loading = false;
    },

    viewDestruccion(idNivel, tipoPrueba) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "DestruccionRegistra",
          params: {
            idNivel: idNivel,
            tipoPrueba: tipoPrueba,
            tipeView: "consulta",
          },
        });
      }, 1000);
    },
  },
};
</script>
